/* istanbul ignore file */
/**
 * Single source of truth for the parent-facing player events.
 * Reused by renderPlayer.js (eventPublisherHandlers) and playerAPI.js (PlayerApi.EVENTS)
 * so the set of subscribable events stays in sync across the iframe boundary.
 */
export const PLAYER_EVENTS = {
  PLAY: 'play',
  PLAYER_READY: 'playerReady',
  TOTAL_TIME_CHANGED: 'totalTimeChanged',
  END: 'end',
  LINK_DISPLAYED: 'linkDisplayed',
  LINK_CLICKED: 'linkClicked',
  REPORT_QUIZ_RESULT: 'reportQuizResult',
  QUIZ_FINISHED: 'quizFinished'
}

export const PLAYER_EVENT_NAMES = Object.values(PLAYER_EVENTS)
